import { ReactNode } from 'react';

import { ToolExtensions } from '@spotify/plugin-confidence-chat-react';

import { CreateChartBlockToolExtension } from './CreateChartBlockToolExtension';
import { CreateChartToolExtension } from './CreateChartToolExtension';
import { CreateSubagentToolExtension } from './CreateSubagentToolExtension';
import { CreateTableBlockToolExtension } from './CreateTableBlockToolExtension';
import { DocumentToolExtension } from './DocumentToolExtension';
import { DrawToolExtension } from './DrawToolExtension';
import {
  CreateFlagPreviewExtension,
  CreateMetricPreviewExtension,
  CreateSegmentPreviewExtension,
  UpdateFlagPreviewExtension,
  UpdateFlagVariantPreviewExtension,
} from './McpToolPreviewExtensions';
import { SaveToPulseToolExtension } from './SaveToPulseToolExtension';
import { TodoWriteToolExtension } from './TodoWriteToolExtension';

type DefaultChatToolExtensionsProps = {
  toolExtensions?: ReactNode;
  previewExtensions?: ReactNode;
};

export const DefaultChatToolExtensions = ({
  toolExtensions,
  previewExtensions,
}: DefaultChatToolExtensionsProps) => (
  <ToolExtensions>
    <CreateChartToolExtension />
    <CreateChartBlockToolExtension />
    <CreateTableBlockToolExtension />
    <CreateSubagentToolExtension />
    <DocumentToolExtension />
    <DrawToolExtension />
    <SaveToPulseToolExtension />
    <TodoWriteToolExtension />
    {toolExtensions}
    <CreateFlagPreviewExtension />
    <UpdateFlagPreviewExtension />
    <UpdateFlagVariantPreviewExtension />
    {previewExtensions}
    <CreateMetricPreviewExtension />
    <CreateSegmentPreviewExtension />
  </ToolExtensions>
);
